// @ts-nocheck
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights, ITelemetryItem } from "@microsoft/applicationinsights-web";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC, PropsWithChildren, useEffect } from "react";

let appInsights: ApplicationInsights | undefined;
const reactPlugin = new ReactPlugin();

export interface AppInsightsProviderProps {}

const AppInsightsProvider: FC<PropsWithChildren<AppInsightsProviderProps>> = ({ children }) => {
    const { connectionString, corsExcludedDomains, roleName } =
        useSettingsCollection().extensionApplicationInsightsSettings || {};

    useEffect(() => {
        if (!appInsights && connectionString) {
            appInsights = new ApplicationInsights({
                config: {
                    autoTrackPageVisitTime: true,
                    connectionString,
                    correlationHeaderExcludedDomains: corsExcludedDomains,
                    disableAjaxTracking: false,
                    enableAutoRouteTracking: true,
                    enableCorsCorrelation: true,
                    enableResponseHeaderTracking: true,
                    enableRequestHeaderTracking: true,
                    extensions: [reactPlugin as any], // "as any" to prevent typing issues (https://github.com/microsoft/applicationinsights-react-js/issues/95)
                },
            });

            try {
                appInsights.loadAppInsights();
            } catch (error) {
                appInsights = undefined;
                console.error(`Application Insights ${error}`); // eslint-disable-line no-console
            }

            appInsights?.addTelemetryInitializer((env: ITelemetryItem) => {
                env.tags = { ...env.tags, "ai.cloud.role": roleName || "" };
            });
        }
    }, [connectionString]);

    return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>;
};

export * from "@microsoft/applicationinsights-react-js";
export default AppInsightsProvider;
